// Padronização de estilos para exportação PDF
export const FONT_TITLE = 13;
export const FONT_HEADER = 10;
export const FONT_BODY = 9;
export const FONT_SUBTITLE = 10;
export const COLOR_HEADER_CONTRATO = [22, 160, 133]; // Verde
export const COLOR_HEADER_CENTRO = [100, 181, 246]; // Azul
export const MARGIN_LEFT = 14;
export const MARGIN_RIGHT = 14; 